// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__233k0","image":"Header_image__YjsOp","name":"Header_name__3vKHr","info":"Header_info__1NqtC","infoRow":"Header_infoRow__2QM8g"};